import React from "react";

export const SaveStatusSaving = "Saving";
export const SaveStatusSaved = "Saved!!";
export const SaveStatusError = "Error";

export const SaveStatus = ({ status }) => {
  return (
    <span>{status ? <div className="save-status">{status}</div> : ""}</span>
  );
};
